(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
/*
 * Toggle the compact state. One passive scroll listener, guarded so a second
 * header instance cannot bind twice.
 */
(function () {
  if (window.__s4shBound) return;
  window.__s4shBound = true;

  /*
   * The header is looked up lazily rather than once at parse time. The section
   * JS bundle can execute before the header element exists, in which case an
   * eager querySelector returns null and the listener is never bound - which is
   * exactly what happened: the header stuck correctly but never gained its
   * compact state.
   */
  var threshold = 40;
  var stuck = null;

  function update() {
    var header = document.querySelector('ecx-sticky-header');
    if (!header) return;
    var next = window.scrollY > threshold;
    if (next === stuck) return;
    stuck = next;
    header.classList.toggle('s4sh--stuck', next);
  }

  window.addEventListener('scroll', update, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-build-mode"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){
    var addons=document.querySelector('[data-ui-component="SAM4S Product Add-ons"]');
    if(!addons)return;
    addons.id='sam4s-complete-setup';
    var p=new URLSearchParams(window.location.search);
    if(p.get('sam4s_build')!=='1')return;
    addons.setAttribute('data-sam4s-build-mode','1');
    var inner=addons.querySelector('.sam4s-addons__inner');
    if(inner&&!inner.querySelector('[data-s4-build-intro]')){
      var intro=document.createElement('div');
      intro.className='s4build__intro';
      intro.setAttribute('data-s4-build-intro','');
      intro.innerHTML='<span>Start with this register, then review the programming, hardware, supplies and protection options linked to it. Compatibility is only treated as established where the product data says so; anything uncertain stays marked for verification.</span>';
      inner.insertBefore(intro,inner.firstChild);
    }
    setTimeout(function(){addons.scrollIntoView({behavior:'smooth',block:'start'});},120);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-business-details"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){
    var form=document.querySelector('[data-s4ow-form]');
    if(!form||form.querySelector('[data-s4-business-section]')) return;
    var businessType=form.querySelector('[name="business_type"]');
    var core=businessType&&businessType.closest('.s4ow__section');
    if(!core) return;
    var section=document.createElement('div');
    section.className='s4ow__section';
    section.setAttribute('data-s4-business-section','');
    section.innerHTML=''+
      '<div class="s4ow__section-head"><span>+</span><div><h3>Business / store details</h3><p>Use the location information that belongs with this register. This helps us match the programming request and prepare receipt text correctly.</p></div></div>'+
      '<div class="s4ow__fields">'+
      '<label class="s4ow__wide">Store address<input type="text" name="business_address" autocomplete="street-address" placeholder="Street address"></label>'+
      '<label>City<input type="text" name="business_city" autocomplete="address-level2"></label>'+
      '<label>State<input type="text" name="business_state" autocomplete="address-level1"></label>'+
      '<label>ZIP / postal code<input type="text" name="business_postal_code" autocomplete="postal-code"></label>'+
      '<label>Store phone for receipt, if different<input type="tel" name="receipt_phone" autocomplete="tel"></label>'+
      '<label class="s4ow__wide">Website / receipt contact text<input type="text" name="receipt_contact" placeholder="Website, email or other contact text you want considered for the receipt"></label>'+
      '</div>'+
      '<p class="s4bd__note">You can still enter the exact receipt header/footer wording in Core programming. These fields identify the store; they do not automatically override your requested receipt text.</p>';
    core.parentNode.insertBefore(section,core);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-buyer-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  /*
   * Filters the buyer's guide comparison. Holds no product knowledge: every
   * fact comes from the data-* attributes the section rendered from structured
   * data. A ticked requirement hides a register that cannot evidence it; a
   * business type hides only a register whose authored use cases exclude it.
   */
  var USE_CASE = {
    retail: 'retail',
    convenience: 'convenience-store',
    liquor: 'liquor-store',
    grocery: 'grocery',
    restaurant: 'food-service',
    cafe: 'food-service',
    service: 'small-business-service'
  };
  var FINDER_BUSINESS = {
    retail: 'retail', convenience: 'convenience', liquor: 'liquor', grocery: 'grocery',
    restaurant: 'restaurant', cafe: 'restaurant', service: 'other', other: 'other'
  };

  function init(root) {
    if (root.getAttribute('data-s4bg-ready')) return;
    root.setAttribute('data-s4bg-ready', '1');
    var form = root.querySelector('[data-s4bg-form]');
    if (!form) return;
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-s4bg-row]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-s4bg-group]'));
    var notes = Array.prototype.slice.call(root.querySelectorAll('[data-s4bg-note]'));
    var status = root.querySelector('[data-s4bg-status]');
    var none = root.querySelector('[data-s4bg-none]');
    var finder = root.querySelector('[data-s4bg-finder]');

    function radio(name) {
      var el = form.querySelector('[name="' + name + '"]:checked');
      return el ? el.value : '';
    }
    function ticked(name) { return !!form.querySelector('[name="' + name + '"]:checked'); }

    function visible(row, a) {
      var d = row.dataset;
      var hybrid = d.group === 'hybrid';
      if (a.keys === 'hybrid' || a.keys === 'touch') {
        if (!hybrid) return false;
      } else if (a.keys === 'raised' || a.keys === 'flat') {
        if (d.kb !== a.keys) return false;
      }
      if (a.uc && !hybrid && d.uc) {
        if ((',' + d.uc).indexOf(',' + a.uc + ',') === -1) return false;
      }
      if (a.scanner && d.scan !== 'true') return false;
      if (a.journal && d.pr !== 'dual') return false;
      if (a.integrated && !d.pay) return false;
      if (a.offline && d.standalone !== 'true') return false;
      if (a.budget && Number(d.cents) > a.budget) return false;
      return true;
    }

    function finderHref(a) {
      var q = [];
      if (a.business && FINDER_BUSINESS[a.business]) q.push('business=' + FINDER_BUSINESS[a.business]);
      if (a.keys === 'raised' || a.keys === 'flat') q.push('keyboard=' + a.keys);
      if (a.keys === 'hybrid') q.push('system=hybrid');
      if (a.keys === 'touch') q.push('system=pos');
      if (a.journal) q.push('printer=dual');
      if (a.scanner) q.push('barcode=1');
      if (a.kitchen) q.push('kitchen=1');
      if (a.display) q.push('display=1');
      if (a.scale) q.push('scale=1');
      if (a.budget) q.push('budget=' + a.budget);
      return '/pages/cash-register-finder' + (q.length ? '?' + q.join('&') : '');
    }

    function update() {
      var business = radio('business');
      var a = {
        business: business,
        uc: USE_CASE[business] || '',
        keys: radio('keys'),
        scanner: ticked('scanner'),
        journal: ticked('journal'),
        integrated: ticked('integrated'),
        kitchen: ticked('kitchen'),
        scale: ticked('scale'),
        display: ticked('display'),
        offline: ticked('offline'),
        nofee: ticked('nofee'),
        budget: Number(radio('budget')) || 0
      };

      var shown = 0;
      rows.forEach(function (row) {
        var ok = visible(row, a);
        row.hidden = !ok;
        if (ok) shown++;
      });
      groups.forEach(function (g) {
        g.hidden = !g.querySelector('[data-s4bg-row]:not([hidden])');
      });

      var active = {};
      if (business) active[business] = true;
      if (a.keys === 'hybrid' || a.keys === 'touch') active[a.keys] = true;
      ['scanner', 'journal', 'integrated', 'kitchen', 'scale', 'display', 'offline', 'nofee'].forEach(function (k) {
        if (a[k]) active[k] = true;
      });
      notes.forEach(function (n) { n.hidden = !active[n.getAttribute('data-s4bg-note')]; });

      if (none) none.hidden = shown > 0;
      if (status) {
        status.textContent = shown === rows.length
          ? 'Showing all ' + rows.length + ' current registers.'
          : 'Showing ' + shown + ' of ' + rows.length + ' current registers that match your choices.';
      }
      if (finder) finder.setAttribute('href', finderHref(a));
    }

    form.addEventListener('change', update);
    update();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-s4bg]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-equipment-registration"] && !Shopify.designMode) return;
  try {
    
(function(){document.querySelectorAll('[data-s4eq-form]').forEach(function(form){form.addEventListener('submit',function(event){event.preventDefault();var fd=new FormData(form);function val(n){return(fd.get(n)||'').toString().trim();}function all(n){return fd.getAll(n).filter(Boolean).join(', ');}var email=val('email'),model=val('register_model'),error=form.querySelector('[data-s4eq-error]');if(!email||!model){if(error)error.hidden=false;var first=!email?form.querySelector('[name="email"]'):form.querySelector('[name="register_model"]');if(first)first.focus();return;}if(error)error.hidden=true;var rows=[['Business',val('business_name')],['Contact',val('contact_name')],['Email',email],['Phone',val('phone')],['Order number',val('order_number')],['Purchase date',val('purchase_date')],['Purchase source',val('purchase_source')],['Programming purchased',val('programming_status')],['SAM4S model',model],['Serial number',val('serial_number')],['Register quantity',val('register_quantity')],['Register status',val('register_status')],['Warranty/protection',val('warranty_status')],['Support agreement',val('support_status')],['Processing relationship',val('processing_status')],['Payment terminal',val('payment_terminal')],['Connected equipment',all('equipment')],['Peripheral models/interfaces',val('peripheral_models')],['Notes',val('notes')]];var lines=['SAM4S EQUIPMENT REGISTRATION',''];rows.forEach(function(r){if(r[1])lines.push(r[0]+': '+r[1]);});var p=new URLSearchParams();p.set('sam4sdirect_lead_type','Existing Customer');p.set('current_pos_system_or_cash_register',model);p.set('message',lines.join('\n'));window.location.href='/pages/contact?'+p.toString();});});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-er945-intake-enhancements"] && !Shopify.designMode) return;
  try {
    
(function(){
  function esc(value){return String(value||'').replace(/[&<>\"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;'}[c];});}
  function option(value,label){return '<option value="'+esc(value)+'">'+esc(label||value)+'</option>';}
  function input(name,type,placeholder){return '<input type="'+type+'" name="'+name+'"'+(placeholder?' placeholder="'+esc(placeholder)+'"':'')+'>';}
  function boot(){
    var form=document.querySelector('[data-s4ow-form]');
    if(!form||form.querySelector('[data-s4-er945-section]')) return;
    var model=form.querySelector('[name="register_model"]');
    if(!model) return;
    var equipmentStep=form.querySelector('[data-equipment-step]');
    var equipmentSection=equipmentStep&&equipmentStep.closest('.s4ow__section');
    var section=document.createElement('div');
    section.className='s4ow__section s4er945';
    section.setAttribute('data-s4-er945-section','');
    section.hidden=true;
    if(equipmentSection) equipmentSection.parentNode.insertBefore(section,equipmentSection); else form.appendChild(section);
    function pluRows(){
      var html='<div class="s4er945__table-wrap"><table class="s4er945__table"><thead><tr><th>Key</th><th>Item / department name</th><th>Open or preset</th><th>Price</th><th>Tax</th></tr></thead><tbody>';
      for(var i=1;i<=21;i++){
        html+='<tr><td>PLU '+i+'</td><td>'+input('er945_plu_'+i+'_name','text','Max 16 characters')+'</td><td><select name="er945_plu_'+i+'_type">'+option('','Select')+option('Open')+option('Preset')+'</select></td><td>'+input('er945_plu_'+i+'_price','text','0.00')+'</td><td><select name="er945_plu_'+i+'_tax">'+option('','Select')+option('NONE')+option('1')+option('2')+option('3')+option('4')+option('1,2')+option('1,3')+option('1,4')+option('2,3')+option('2,4')+option('3,4')+option('1,2,3')+option('1,2,4')+option('1,3,4')+option('2,3,4')+option('1,2,3,4')+'</select></td></tr>';
      }
      return html+'</tbody></table></div>';
    }
    function receiptRows(kind,label){
      var html='<fieldset class="s4er945__receipt"><legend>'+label+'</legend>';
      for(var i=1;i<=6;i++) html+='<label>Line '+i+' '+input('er945_'+kind+'_'+i,'text','Maximum 32 characters')+'</label>';
      return html+'</fieldset>';
    }
    function taxRows(){
      var html='<div class="s4er945__tax-grid">';
      for(var i=1;i<=4;i++) html+='<div class="s4er945__tax-card"><strong>Tax '+i+'</strong><label>Rate % '+input('er945_tax_'+i+'_rate','text','7.000')+'</label><label>Mode<select name="er945_tax_'+i+'_mode">'+option('','Select')+option('Add on')+option('Included')+'</select></label><label>Applies to '+input('er945_tax_'+i+'_applies','text','Departments/items')+'</label></div>';
      return html+'</div>';
    }
    function clerkRows(){
      var html='<div class="s4er945__table-wrap"><table class="s4er945__table"><thead><tr><th>Clerk</th><th>ID</th><th>Name</th><th>Permissions / notes</th></tr></thead><tbody>';
      for(var i=1;i<=8;i++) html+='<tr><td>'+i+'</td><td>'+input('er945_clerk_'+i+'_id','text','ID')+'</td><td>'+input('er945_clerk_'+i+'_name','text','Name')+'</td><td>'+input('er945_clerk_'+i+'_notes','text','Manager/restrictions')+'</td></tr>';
      return html+'</tbody></table></div>';
    }
    function render(){
      if((model.value||'').toUpperCase()!=='ER-945E'){section.hidden=true;section.innerHTML='';return;}
      section.hidden=false;
      section.innerHTML=''+
        '<div class="s4ow__section-head"><span>+</span><div><h3>ER-945E detailed programming worksheet</h3><p>Complete the fields you know. Leave anything blank that you want our technician to review with you.</p></div></div>'+
        '<div class="s4er945__note"><strong>Raised-keyboard setup:</strong> the standard worksheet uses 21 double-width PLU keys. Each item name should be 16 characters or fewer. Prices and tax assignments are entered below.</div>'+
        '<div class="s4ow__fields">'+
          '<label>Receipt printing<select name="er945_receipt_mode">'+option('','Select')+option('Always print')+option('Print on request')+'</select></label>'+
          '<label>Clerk sign-on required?<select name="er945_clerk_signon">'+option('','Select')+option('Yes')+option('No')+'</select></label>'+
          '<label class="s4ow__wide">Tax jurisdiction / source<input type="text" name="er945_tax_jurisdiction" placeholder="State, county, city and verification source/effective date"></label>'+
          '<label class="s4ow__wide">Tender names<input type="text" name="er945_tenders" placeholder="Cash, Check, Credit, Debit, EBT, Gift Card, etc."></label>'+
          '<label class="s4ow__wide">Discounts / refunds / void / no-sale restrictions<textarea name="er945_operating_rules" rows="3"></textarea></label>'+
        '</div>'+
        '<h4>PLU keys 1-21</h4>'+pluRows()+
        '<h4>Tax rates</h4>'+taxRows()+
        '<div class="s4er945__receipt-grid">'+receiptRows('header','Receipt header — up to 6 lines')+receiptRows('footer','Receipt footer — up to 6 lines')+'</div>'+
        '<h4>Clerks</h4>'+clerkRows()+
        '<div class="s4ow__fields s4ow__mt">'+
          '<label class="s4ow__wide">Scanner, scale, payment terminal or other peripherals<textarea name="er945_peripherals" rows="3" placeholder="List exact models when known."></textarea></label>'+
          '<label class="s4ow__wide">Additional programming requests<textarea name="er945_additional" rows="4"></textarea></label>'+
          '<label>Existing ER-945E program available?<select name="er945_existing_program">'+option('','Select')+option('No - new setup')+option('Yes - electronic backup/file')+option('Yes - printed program reports')+option('Yes - keyboard/receipt photos only')+option('Not sure')+'</select></label>'+
          '<label>Preferred transfer method, if known<select name="er945_transfer_preference">'+option('','Let technician choose')+option('PC programming utility')+option('Network/Ethernet')+option('SD card')+option('Other / not sure')+'</select></label>'+
        '</div>';
    }
    function summarize(){
      var values=[];
      section.querySelectorAll('input,select,textarea').forEach(function(el){
        if(!el.name) return;
        var v=(el.value||'').trim(); if(!v) return;
        values.push(el.name+': '+v);
      });
      return values;
    }
    model.addEventListener('change',render);
    render();
    form.addEventListener('submit',function(){
      if(section.hidden) return;
      var notes=form.querySelector('[name="project_notes"]');
      if(!notes) return;
      var marker='\n\n--- ER-945E DETAILED PROGRAMMING WORKSHEET ---\n';
      var base=notes.value.split(marker)[0];
      var detail=summarize();
      notes.value=base+(detail.length?marker+detail.join('\n'):'');
    },true);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-finder-build-bridge"] && !Shopify.designMode) return;
  try {
    
(function () {
  /*
   * The Finder and the builder grew separate vocabularies. Mapping them here,
   * once and explicitly, beats letting either guess. An unmapped value simply
   * does not travel, and that is the right failure: a wrongly preselected
   * business type is worse than an unanswered one, because the customer has to
   * notice it before they can correct it.
   */
  var BUSINESS = {
    retail: 'retail',
    restaurant: 'food-service',
    liquor: 'liquor-store',
    convenience: 'convenience-store',
    grocery: 'grocery',
    nonprofit: 'small-business-service'
    // "other" is deliberately absent: it maps to nothing honest.
  };

  /* Finder intents that mean "there is already a register on the counter". */
  var REPLACING = { replace: 1, upgrade: 1, broken: 1 };

  function answer(root, name) {
    var checked = root.querySelector('[name="' + name + '"]:checked');
    if (checked) return (checked.value || '').trim();
    var el = root.querySelector('[name="' + name + '"]');
    if (!el || el.type === 'radio' || el.type === 'checkbox') return '';
    return (el.value || '').trim();
  }

  function handleFrom(href) {
    var m = String(href || '').match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : '';
  }

  /*
   * Built from the answers as they stand RIGHT NOW.
   *
   * The first version composed each href once, when the cards were created.
   * The Finder is a live form - the customer keeps answering after the cards
   * appear - so those links froze whatever was selected at boot: a restaurant
   * handed over as retail, and a replacement handed over as a new purchase.
   * The URL looked perfectly well-formed, which is why it would have survived
   * review. Recomputed on every change, and again on the click itself.
   */
  function hrefFor(root, base, handle) {
    var intent = answer(root, 'intent');
    var current = answer(root, 'current_model');
    var replacing = Boolean(current && REPLACING[intent]);
    var biz = BUSINESS[answer(root, 'business')];

    var q = ['v=1'];
    q.push('path=' + (replacing ? 'B' : 'A'));
    q.push('register=' + encodeURIComponent(handle));
    q.push('from=register-finder');
    if (biz) q.push('biz=' + encodeURIComponent(biz));
    if (replacing) q.push('currentRegister=' + encodeURIComponent(current));

    /*
     * Open past what the Finder already settled. If the business type did not
     * map we start at that question rather than guessing - one honest question
     * beats a wrong preselection the customer has to notice and undo.
     */
    q.push('step=' + (biz ? 'scanner' : 'biz'));

    return {
      url: base + '?' + q.join('&') + '#solution-builder',
      path: replacing ? 'B' : 'A',
      preloaded: q.filter(function (p) {
        return /^(register|biz|currentRegister)=/.test(p);
      }).map(function (p) { return p.split('=')[0]; }).join(',')
    };
  }

  function refresh(root, base) {
    root.querySelectorAll('[data-s4f-builder]').forEach(function (a) {
      a.href = hrefFor(root, base, a.getAttribute('data-s4f-model')).url;
    });
  }

  function boot() {
    var bridge = document.querySelector('[data-s4f-build-bridge]');
    var base = (bridge && bridge.getAttribute('data-builder-url')) || '/pages/merchant-processing';

    document.querySelectorAll('[data-s4f]').forEach(function (root) {
      root.querySelectorAll('[data-card]').forEach(function (card) {
        var box = card.querySelector('.s4f__ctas');
        var view = card.querySelector('.s4f__text-link');
        if (!box || !view || box.querySelector('[data-s4f-build]')) return;
        var href = view.getAttribute('href') || '';
        if (!href) return;

        var link = document.createElement('a');
        link.className = 's4f__mini';
        link.setAttribute('data-s4f-build', '');
        link.href = href + (href.indexOf('?') > -1 ? '&' : '?') + 'sam4s_build=1#sam4s-complete-setup';
        link.textContent = 'Build complete setup';
        box.appendChild(link);

        var handle = handleFrom(href);
        if (!handle) return;

        var build = document.createElement('a');
        build.className = 's4f__mini';
        build.setAttribute('data-s4f-builder', '');
        build.setAttribute('data-s4f-model', handle);
        build.textContent = 'Build the whole setup';
        build.href = hrefFor(root, base, handle).url;
        box.appendChild(build);
      });

      if (!root.hasAttribute('data-s4f-bridge-bound')) {
        root.setAttribute('data-s4f-bridge-bound', '');

        /* Answers keep changing after the cards exist. */
        root.addEventListener('change', function () { refresh(root, base); });
        root.addEventListener('input', function () { refresh(root, base); });

        /* And once more at the click, so a card added or changed between the
           last event and the click still hands over the truth. */
        root.addEventListener('click', function (ev) {
          var a = ev.target.closest && ev.target.closest('[data-s4f-builder]');
          if (!a) return;
          var built = hrefFor(root, base, a.getAttribute('data-s4f-model'));
          a.href = built.url;
          if (window.S4SAnalytics && typeof window.S4SAnalytics.emit === 'function') {
            window.S4SAnalytics.emit('s4s_builder_entry', {
              entry_path: built.path,
              entry_surface: 'register_finder',
              model: a.getAttribute('data-s4f-model'),
              preloaded: built.preloaded
            });
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-finder-handoff"] && !Shopify.designMode) return;
  try {
    
(function(){function boot(){document.querySelectorAll('[data-s4f]').forEach(function(root){if(root.dataset.onboardingHandoff)return;root.dataset.onboardingHandoff='1';var form=root.querySelector('[data-form]');if(!form)return;function value(name){var checked=form.querySelector('[name="'+name+'"]:checked');if(checked)return checked.value;var el=form.querySelector('[name="'+name+'"]');return el?el.value:'';}function build(card){var model=(card.dataset.model||'').trim();if(!model)return'';var intent=value('intent'),old=value('current_model').trim(),project='New register programming';if(intent==='replace'||intent==='upgrade'||intent==='broken')project='Replace an older register';else if(intent==='add')project='Add another register';var p=new URLSearchParams();p.set('model',model);p.set('project_type',project);if(old)p.set('old_model',old);var cur=new URLSearchParams(window.location.search);['preview_theme_id','_fd','pb'].forEach(function(k){if(cur.get(k))p.set(k,cur.get(k));});return'/pages/sam4s-register-onboarding?'+p.toString();}function update(){root.querySelectorAll('[data-card]').forEach(function(card){var box=card.querySelector('.s4f__ctas');if(!box)return;var link=box.querySelector('[data-s4f-onboard]');if(card.hidden){if(link)link.hidden=true;return;}var href=build(card);if(!href){if(link)link.hidden=true;return;}if(!link){link=document.createElement('a');link.className='s4f__mini';link.setAttribute('data-s4f-onboard','');box.appendChild(link);}link.hidden=false;link.href=href;var intent=value('intent');link.textContent=(intent==='replace'||intent==='upgrade'||intent==='broken')?'Continue replacement worksheet':'Continue with this model';});}form.addEventListener('submit',function(){setTimeout(update,0);});form.addEventListener('reset',function(){setTimeout(function(){root.querySelectorAll('[data-s4f-onboard]').forEach(function(a){a.hidden=true;});},0);});});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-finder-scope-guard"] && !Shopify.designMode) return;
  try {
    
(function(){
  function replaceText(root,pairs){
    if(!root)return;
    var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    var node;
    while((node=walker.nextNode())){
      var text=node.nodeValue;
      pairs.forEach(function(pair){text=text.split(pair[0]).join(pair[1]);});
      if(node.nodeValue!==text)node.nodeValue=text;
    }
  }
  function boot(){
    document.querySelectorAll('[data-s4f]').forEach(function(root){
      if(root.dataset.sam4sSingleLocation==='1')return;
      root.dataset.sam4sSingleLocation='1';
      var form=root.querySelector('[data-form]');
      if(!form)return;
      var locations=form.querySelector('[name="locations"]');
      if(locations){
        locations.value='1';
        var locationField=locations.closest('.s4f__field');
        if(locationField)locationField.hidden=true;
      }
      var newBusiness=form.querySelector('[name="intent"][value="new"]');
      if(newBusiness){
        var card=newBusiness.closest('label');
        var title=card&&card.querySelector('b');
        var small=card&&card.querySelector('small');
        if(title)title.textContent='New business / new checkout';
        if(small)small.textContent='Build the complete register setup.';
      }
      var pairs=[
        ['Multiple locations, registers, connected equipment or higher processing volume make this better suited to a coordinated quote.','Multiple registers, connected equipment or higher processing volume make this better suited to a coordinated quote.'],
        ['Multi-register and multi-location setups are quoted after we confirm the workflow at each counter.','Multi-register setups are quoted after we confirm the workflow at each counter.'],
        ['1 location(s), ','']
      ];
      var route=root.querySelector('[data-route]');
      var summary=root.querySelector('[data-summary]');
      [route,summary].forEach(function(el){if(!el)return;new MutationObserver(function(){replaceText(el,pairs);}).observe(el,{childList:true,subtree:true,characterData:true});});
      form.addEventListener('submit',function(){if(locations)locations.value='1';setTimeout(function(){replaceText(route,pairs);replaceText(summary,pairs);},0);},true);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-hubspot-form"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-s4hs]').forEach(function (section) {
      // source_page carries WHICH SAM4sDirect surface sent the visitor. It is a
    // free-text contact string in portal 5858156 and exists for exactly this.
    //
    // It is deliberately not sam4sdirect_lead_type (the primary reason for
    // contact, which drives routing and ownership), not
    // sam4sdirect_merchant_processing_interest (a secondary signal that must
    // not move ownership by itself), and not a UTM field, which is acquisition
    // tracking that internal navigation would make unreadable.
    var allowed = [
    'sam4sdirect_lead_type',
    'sam4sdirect_merchant_processing_interest',
    'current_pos_system_or_cash_register',
    'message',
      'source_page'
    ];
  var source = new URLSearchParams(window.location.search);
  var destination = new URL(section.dataset.formUrl);
  // source_page is a free-text CRM property that the page URL could otherwise fill with anything. Accept only the shape this theme emits
  // (sam4sdirect:<page-or-product-handle>); drop any other value rather than store it. Other names are unchanged.
  var sourcePageShape = /^sam4sdirect:[a-z0-9][a-z0-9._-]{0,99}$/;
  allowed.forEach(function (name) {
    if (!source.has(name)) return;
    if (name === 'source_page' && !sourcePageShape.test(source.get(name))) return;
    destination.searchParams.set(name, source.get(name));
  });
  var frame = section.querySelector('.s4hs__frame');
  var fallback = section.querySelector('[data-s4hs-fallback]');
  if (frame) frame.src = destination.toString();
  if (fallback) fallback.href = destination.toString();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-intake-final-qa"] && !Shopify.designMode) return;
  try {
    
(function(){
function boot(){
 var form=document.querySelector('[data-s4ow-form]');if(!form)return;
 var model=form.querySelector('[name="register_model"]'),project=form.querySelector('[name="project_type"]'),old=form.querySelector('[name="old_model"]'),error=form.parentElement.querySelector('[data-s4ow-error]'),status=document.querySelector('[data-s4qa]');
 var life=window.SAM4S_MODEL_LIFECYCLE||{current:[],legacy:[]};var current=life.current.map(function(x){return x.model;});var legacy=life.legacy.map(function(x){return x.model;});
 function mode(){var v=(project&&project.value||'').toLowerCase();return /programming changes|remote programming|support/.test(v)?'support':(/replace|transfer|add another/.test(v)?'replacement':'new');}
 function actualModel(){return(model&&model.value||'').trim();}
 function isLegacy(v){return legacy.indexOf(v)>-1||/^ER-52/.test(v)||/^NR-500/.test(v)||/^SPS-500/.test(v)||v==='ER-925';}
 function incomplete(){var missing=[];if(!form.querySelector('[name="purchaser_email"]').value.trim())missing.push('email');if(!actualModel())missing.push('register model');if(!project.value)missing.push('project type');if(mode()==='replacement'&&!old.value.trim())missing.push('old/current register model');return missing;}
 function update(){
  var m=mode(),v=actualModel();
  if(model)Array.prototype.forEach.call(model.options,function(o){if(!o.value)return;var legacyChoice=isLegacy(o.value);if(m!=='support'&&legacyChoice){o.hidden=true;o.disabled=true;}else if(legacyChoice){o.hidden=false;o.disabled=false;}});
  if(m!=='support'&&v&&isLegacy(v)){model.value='';model.dispatchEvent(new Event('change',{bubbles:true}));}
  if(old){old.required=m==='replacement';old.setAttribute('aria-required',m==='replacement'?'true':'false');}
  var missing=incomplete();if(status){status.hidden=!missing.length;status.textContent=missing.length?'Before sending, please complete: '+missing.join(', ')+'.':'';}
 }
 [model,project,old].forEach(function(el){if(el){el.addEventListener('change',update);el.addEventListener('input',update);}});var email=form.querySelector('[name="purchaser_email"]');if(email)email.addEventListener('input',update);
 form.addEventListener('submit',function(ev){var missing=incomplete();var v=actualModel();if(mode()!=='support'&&isLegacy(v))missing.push('a current replacement/new model');if(missing.length){ev.preventDefault();ev.stopImmediatePropagation();if(error){error.hidden=false;error.textContent='Please complete '+missing.join(', ')+' before continuing.';}if(status){status.hidden=false;status.textContent='Please complete '+missing.join(', ')+' before continuing.';}var target=!email.value.trim()?email:(!actualModel()?model:(!project.value?project:old));if(target)target.focus();return;}if(error)error.hidden=true;},true);
 update();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-intake-reliability"] && !Shopify.designMode) return;
  try {
    
(function(){
  var form=document.querySelector('[data-s4ow-form]');
  if(!form) return;
  var key='sam4sdirect-programming-intake-v1';
  var status=document.querySelector('[data-s4ir]');
  var pageParams=new URLSearchParams(window.location.search);
  var submitted=pageParams.get('contact_posted')==='1'||pageParams.get('programming_intake_saved')==='1';
  function eligible(el){return el.name && !el.disabled && el.type!=='submit' && el.type!=='button';}
  function snapshot(){var data={};Array.prototype.forEach.call(form.elements,function(el){if(!eligible(el)) return;if(el.type==='checkbox'){if(!data[el.name]) data[el.name]=[];if(el.checked) data[el.name].push(el.value);return;}if(el.type==='radio'){if(el.checked) data[el.name]=el.value;return;}data[el.name]=el.value;});try{localStorage.setItem(key,JSON.stringify({savedAt:Date.now(),data:data}));}catch(e){}}
  function restore(){var raw;try{raw=localStorage.getItem(key);}catch(e){}if(!raw) return;var saved;try{saved=JSON.parse(raw);}catch(e){return;}if(!saved||!saved.data) return;Object.keys(saved.data).forEach(function(name){var value=saved.data[name];Array.prototype.forEach.call(form.querySelectorAll('[name="'+CSS.escape(name)+'"]'),function(el){if(el.type==='checkbox'){el.checked=Array.isArray(value)&&value.indexOf(el.value)>-1;}else if(el.type==='radio'){el.checked=value===el.value;}else if(!el.value){el.value=value;}});});form.querySelectorAll('select,input').forEach(function(el){el.dispatchEvent(new Event('change',{bubbles:true}));});if(status){status.hidden=false;status.textContent='Your saved worksheet draft was restored on this device.';}}
  if(submitted){try{localStorage.removeItem(key);}catch(e){}if(status){status.hidden=false;status.textContent='Programming request saved. We can review the worksheet before programming or quoting the register.';}return;}
  restore();var timer;form.addEventListener('input',function(){clearTimeout(timer);timer=setTimeout(snapshot,350);});form.addEventListener('change',snapshot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-intake-review"] && !Shopify.designMode) return;
  try {
    
(function(){
function boot(){
  var form=document.querySelector('[data-s4ow-form]');
  if(!form||form.querySelector('[data-s4review]')) return;
  var finish=form.querySelector('.s4ow__finish');
  if(!finish) return;
  var box=document.createElement('div');
  box.className='s4ow__section s4review';
  box.setAttribute('data-s4review','');
  box.innerHTML=''+
    '<div class="s4ow__section-head"><span>✓</span><div><h3>Review before you send</h3><p>Check the key details below. This is a summary, not a promise that an older program can be restored directly to a different register.</p></div></div>'+
    '<div class="s4review__grid">'+
      '<div><small>Target register</small><strong data-s4review-model>Not selected</strong></div>'+
      '<div><small>Project</small><strong data-s4review-project>Not selected</strong></div>'+
      '<div><small>Old/current register</small><strong data-s4review-old>Not provided</strong></div>'+
      '<div><small>Register quantity</small><strong data-s4review-qty>1</strong></div>'+
      '<div><small>Equipment / setup</small><strong data-s4review-equipment>None selected yet</strong></div>'+
      '<div><small>Card processing</small><strong data-s4review-processing>Not selected</strong></div>'+
      '<div><small>Source files / photos</small><strong data-s4review-files>None selected yet</strong></div>'+
      '<div><small>Timing</small><strong data-s4review-timing>Not specified</strong></div>'+
    '</div>'+
    '<div class="s4review__transfer" data-s4review-transfer><strong data-s4review-transfer-label>Transfer path</strong><p data-s4review-transfer-copy></p></div>'+
    '<p class="s4review__note"><strong>Before programming begins:</strong> we verify the exact model, firmware/options where relevant, peripheral compatibility and any old-program material you provide.</p>';
  finish.parentNode.insertBefore(box,finish);

  function one(name){var el=form.querySelector('[name="'+name+'"]');return el?(el.value||'').toString().trim():'';}
  function checked(name){var vals=[];Array.prototype.forEach.call(form.querySelectorAll('[name="'+name+'"]'),function(el){if(el.checked&&el.value)vals.push(el.value);});return vals;}
  function set(sel,value,fallback){var el=box.querySelector(sel);if(el)el.textContent=value||fallback||'';}
  function replacementMode(){return /replace|transfer|add another/i.test(one('project_type'));}
  function family(value){
    value=(value||'').toUpperCase().trim();
    if(!value) return '';
    if(/ER-9(15|20|25|40|45)E/.test(value)||value==='ER-925'||value.indexOf('ER-900')===0) return 'ER-900';
    if(value.indexOf('NR-510')===0||value.indexOf('NR-500')===0) return 'NR-500/510';
    if(value.indexOf('SPS-3')===0) return 'SPS-300';
    if(value.indexOf('SPS-5')===0) return 'SPS-500';
    if(value.indexOf('ER-5200')===0||value.indexOf('ER-5240')===0||value.indexOf('ER-52')===0) return 'ER-5200/5240';
    if(/^ER-26(0|5)/.test(value)) return 'ER-260/265';
    return '';
  }
  function classify(){
    var target=one('register_model'),old=one('old_model');
    if(!replacementMode()) return {key:'new',label:'New/current programming job',copy:'No old-register transfer is assumed. Programming will be built for the selected current register from the information you provide.'};
    if(target==='Replacement model not selected yet') return {key:'pending',label:'Replacement model still needs verification',copy:'We will use the old register model, workflow and connected equipment to verify the appropriate current replacement before quoting or programming.'};
    if(!old) return {key:'unknown-old',label:'Old register information still needed',copy:'A model number, clear model-label photo, receipt or program report will help us decide whether this can be treated as a migration or needs to be rebuilt.'};
    var a=family(old),b=family(target);
    if(a&&b&&a===b) return {key:'same-family',label:'Likely same-family migration candidate',copy:'Existing backup, program reports and keyboard information can speed recreation. We still verify firmware, memory/options and exact-model differences before attempting any restore or transfer.'};
    if(a&&b&&a!==b) return {key:'cross-family',label:'Cross-family migration / rebuild',copy:'The old setup is useful as a reference, but this should be treated as a recreation or migration — not a byte-for-byte program clone.'};
    return {key:'verify',label:'Transfer method needs verification',copy:'We have enough to start the review, but the exact transfer path depends on the confirmed old and target models plus the program information available.'};
  }
  function update(){
    set('[data-s4review-model]',one('register_model'),'Not selected');
    set('[data-s4review-project]',one('project_type'),'Not selected');
    set('[data-s4review-old]',one('old_model'),'Not provided');
    set('[data-s4review-qty]',one('register_quantity'),'1');
    var equipment=checked('setup_need').concat(checked('quote_include'));
    var unique=[];equipment.forEach(function(v){if(unique.indexOf(v)===-1)unique.push(v);});
    set('[data-s4review-equipment]',unique.join(', '),'None selected yet');
    var processing=one('payment_approach')||one('quote_pricing_interest');
    set('[data-s4review-processing]',processing,'Not selected');
    var files=checked('replacement_source').concat(checked('upload_type'));
    var uniqueFiles=[];files.forEach(function(v){if(uniqueFiles.indexOf(v)===-1)uniqueFiles.push(v);});
    set('[data-s4review-files]',uniqueFiles.join(', '),'None selected yet');
    var timing=[one('urgency'),one('go_live')].filter(Boolean).join(' • ');
    set('[data-s4review-timing]',timing,'Not specified');
    var c=classify();box.setAttribute('data-transfer-classification',c.key);set('[data-s4review-transfer-label]',c.label);set('[data-s4review-transfer-copy]',c.copy);
  }
  form.addEventListener('input',update);
  form.addEventListener('change',update);
  form.addEventListener('submit',function(){
    var notes=form.querySelector('[name="project_notes"]');if(!notes)return;
    var c=classify();var marker='\n\n--- TRANSFER / MIGRATION CLASSIFICATION ---\n';var base=notes.value.split(marker)[0];
    var lines=['Transfer classification: '+c.label];
    var old=one('old_model'),target=one('register_model');if(old)lines.push('Old/current model: '+old);if(target)lines.push('Target model: '+target);lines.push('Expectation: '+c.copy);
    notes.value=base+marker+lines.join('\n');
  },true);
  setTimeout(update,0);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-internal-job-packet"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){
    var form=document.querySelector('[data-s4ow-form]');
    if(!form||form.querySelector('[name="internal_job_packet"]')) return;
    var packet=document.createElement('textarea');
    packet.name='internal_job_packet';
    packet.hidden=true;
    packet.setAttribute('aria-hidden','true');
    form.appendChild(packet);

    function one(name){
      var el=form.querySelector('[name="'+name+'"]');
      return el?(el.value||'').toString().trim():'';
    }
    function many(name){
      var vals=[];
      Array.prototype.forEach.call(form.querySelectorAll('[name="'+name+'"]'),function(el){
        if((el.type==='checkbox'||el.type==='radio')&&!el.checked) return;
        var v=(el.value||'').toString().trim();
        if(v) vals.push(v);
      });
      return vals;
    }
    function add(lines,label,value){
      if(value) lines.push(label+': '+value);
    }
    function build(){
      var lines=[];
      lines.push('SAM4SDIRECT INTERNAL PROGRAMMING JOB PACKET');
      lines.push('===========================================');
      lines.push('STATUS: INTAKE RECEIVED - REVIEW REQUIRED');
      lines.push('SHIPMENT HOLD: DO NOT SHIP UNTIL PROGRAMMING + QA ARE COMPLETE');
      lines.push('PROGRAMMING METHOD: MANUAL FOR NOW');
      lines.push('');
      lines.push('ORDER / CUSTOMER');
      lines.push('----------------');
      add(lines,'Order number',one('order_number'));
      add(lines,'Business',one('business_name'));
      add(lines,'Contact',one('contact_name'));
      add(lines,'Email',one('purchaser_email'));
      add(lines,'Phone',one('phone'));
      add(lines,'Target model',one('register_model'));
      add(lines,'Quantity',one('register_quantity'));
      add(lines,'Project type',one('project_type'));
      add(lines,'Old/current register',one('old_model'));
      add(lines,'Requested go-live',one('go_live'));
      add(lines,'Urgency',one('urgency'));
      lines.push('');
      lines.push('SOURCE MATERIAL');
      lines.push('---------------');
      add(lines,'Replacement/source material',many('replacement_source').join(', '));
      add(lines,'Files/photos available',many('upload_type').join(', '));
      add(lines,'Existing ER-945E program source',one('er945_existing_program'));
      lines.push('');
      var spec=one('technician_programming_spec');
      if(spec){
        lines.push(spec);
        lines.push('');
      }
      lines.push('INTERNAL REVIEW');
      lines.push('---------------');
      lines.push('[ ] Order and customer matched');
      lines.push('[ ] Exact model confirmed');
      lines.push('[ ] Programming information complete');
      lines.push('[ ] Tax information supplied/approved by customer');
      lines.push('[ ] Peripheral compatibility reviewed');
      lines.push('[ ] Payment workflow reviewed if applicable');
      lines.push('[ ] Missing/conflicting information resolved');
      lines.push('');
      lines.push('TECHNICIAN COMPLETION');
      lines.push('---------------------');
      lines.push('Technician: ______________________________');
      lines.push('Date programmed: _________________________');
      lines.push('Serial number(s): ________________________');
      lines.push('[ ] Programming completed from approved specification');
      lines.push('[ ] Test transaction completed');
      lines.push('[ ] Receipt reviewed');
      lines.push('[ ] Taxes/prices verified');
      lines.push('[ ] Clerks/tenders verified');
      lines.push('[ ] Peripherals tested as applicable');
      lines.push('[ ] Backup/configuration saved when supported');
      lines.push('[ ] QA COMPLETE');
      lines.push('');
      lines.push('SHIPMENT RELEASE');
      lines.push('----------------');
      lines.push('[ ] READY TO SHIP');
      lines.push('Released by: _____________________________');
      lines.push('Release date: ____________________________');
      lines.push('Exception / change notes:');
      lines.push('________________________________________________________');
      lines.push('________________________________________________________');
      lines.push('');
      lines.push('IMPORTANT: Program tax rates/classifications from customer-supplied or customer-approved information. Do not guess missing programming values.');
      packet.value=lines.join('\n');
    }

    form.addEventListener('input',build);
    form.addEventListener('change',build);
    form.addEventListener('submit',build,true);
    build();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-lifecycle-bridge"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){
    var lifecycle=window.SAM4S_MODEL_LIFECYCLE||{current:[],legacy:[],aliases:{}};
    var finder=document.querySelector('[data-s4f]');
    var oldInput=finder&&finder.querySelector('[name="current_model"]');

    function clean(value){return (value||'').trim().toUpperCase().replace(/[^A-Z0-9]+/g,' ');}
    function legacyRecord(value){
      var target=clean(value);
      for(var i=0;i<lifecycle.legacy.length;i++){
        if(clean(lifecycle.legacy[i].model)===target) return lifecycle.legacy[i];
      }
      return null;
    }
    function currentRecordFromText(value){
      var hay=' '+clean(value)+' ';
      for(var i=0;i<lifecycle.current.length;i++){
        var needle=' '+clean(lifecycle.current[i].model)+' ';
        if(hay.indexOf(needle)!==-1) return lifecycle.current[i];
      }
      return null;
    }
    function onboardingUrl(oldModel, intent, replacementModel){
      var project='Replace an older register';
      if(intent==='add') project='Add another register';
      var q=new URLSearchParams();
      q.set('project_type',project);
      if(oldModel) q.set('old_model',oldModel);
      if(replacementModel) q.set('replacement_model',replacementModel);
      return '/pages/sam4s-register-onboarding?'+q.toString();
    }

    if(oldInput){
      var list=document.createElement('datalist');
      list.id='sam4s-known-models';
      var seen={};
      lifecycle.current.concat(lifecycle.legacy).forEach(function(item){
        if(!item.model||seen[item.model]) return;
        seen[item.model]=true;
        var opt=document.createElement('option');opt.value=item.model;list.appendChild(opt);
      });
      ['ER-5200 / ER-5240 Series','SPS-300 Series','ER-900 / ER-900E Series','Other / not sure'].forEach(function(name){
        if(seen[name]) return;var opt=document.createElement('option');opt.value=name;list.appendChild(opt);
      });
      oldInput.setAttribute('list',list.id);
      oldInput.parentNode.appendChild(list);

      var note=document.createElement('small');
      note.setAttribute('data-lifecycle-note','');
      note.textContent='Current and discontinued SAM4S models are accepted here. This identifies what you own; discontinued models are never recommended as new purchases.';
      oldInput.parentNode.appendChild(note);

      oldInput.addEventListener('change',function(){
        var rec=legacyRecord(oldInput.value);
        if(rec){
          note.textContent=rec.replacement ? ('Legacy model recognized. Closest current SAM4S fit: '+rec.replacement+' (a documented feature comparison, not a manufacturer replacement statement). We still verify keyboard, printer, peripherals and programming before ordering.') : 'Legacy/support model recognized. We will use it to guide replacement or programming support, not as a new-sale recommendation.';
        }else{
          note.textContent='Current and discontinued SAM4S models are accepted here. This identifies what you own; discontinued models are never recommended as new purchases.';
        }
      });

      var form=finder.querySelector('[data-form]');
      if(form){
        form.addEventListener('submit',function(){
          setTimeout(function(){
            var intentEl=form.querySelector('[name="intent"]:checked');
            var intent=intentEl?intentEl.value:'';
            if(['broken','replace','upgrade','add'].indexOf(intent)===-1) return;
            var route=finder.querySelector('[data-route]');
            if(!route) return;
            var actions=route.querySelector('.s4f__actions');
            if(!actions||actions.querySelector('[data-replacement-intake]')) return;
            var legacy=legacyRecord(oldInput.value);
            var replacement=legacy&&legacy.replacement?legacy.replacement:'';
            var a=document.createElement('a');
            a.className='s4f__secondary';
            a.setAttribute('data-replacement-intake','');
            a.href=onboardingUrl(oldInput.value.trim(),intent,replacement);
            a.textContent='Start replacement / programming intake';
            actions.appendChild(a);
          },0);
        });
      }
    }

    document.querySelectorAll('.srf__card').forEach(function(card){
      var legacy=card.querySelector('.srf__legacy');
      var oldModel=legacy?legacy.textContent.trim():'';
      if(!oldModel) return;
      var side=card.querySelector('.srf__card-side');
      if(!side) return;
      var direction=card.querySelector('.srf__direction-value');
      var replacementModel=direction?direction.textContent.trim():'';
      var exact=side.querySelector('.srf__exact');
      if(exact){
        var productLinks=exact.querySelectorAll('.srf__prod');
        var validCurrent=false;
        productLinks.forEach(function(link){
          var evidence=[link.textContent,link.getAttribute('href')||'',link.getAttribute('aria-label')||''].join(' ');
          if(currentRecordFromText(evidence)) validCurrent=true;
        });
        if(productLinks.length && !validCurrent){
          productLinks.forEach(function(link){link.remove();});
          var label=exact.querySelector('.srf__label');
          if(label){label.textContent='Replacement link held for verification';label.classList.remove('srf__label--ok');}
          var note=exact.querySelector('.srf__exact-note');
          if(note){note.textContent='The linked catalog item is not confirmed against the current-model lifecycle list, so we are not presenting it as a buyable replacement. Start the replacement intake and we will verify the current supported model first.';}
          replacementModel='';
        }
      }
      if(side.querySelector('[data-srf-intake]')) return;
      var wrap=document.createElement('div');
      wrap.className='srf__intake';
      var a=document.createElement('a');
      a.className='srf__btn';
      a.setAttribute('data-srf-intake','');
      a.href=onboardingUrl(oldModel,'replace',replacementModel);
      a.textContent='Start replacement / programming intake';
      wrap.appendChild(a);
      side.appendChild(wrap);
    });

    document.querySelectorAll('.srf__next-block--contact .srf__btn,.srf__empty .srf__btn').forEach(function(a){
      a.href=onboardingUrl('','replace','');
      a.textContent='Start replacement intake';
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-onboarding-corrections"] && !Shopify.designMode) return;
  try {
    
(function(){function boot(){var form=document.querySelector('[data-s4ow-form]');if(!form)return;var old=form.querySelector('[name="old_model"]');if(old&&old.parentElement&&!old.parentElement.querySelector('[data-photo-help]')){var help=document.createElement('small');help.setAttribute('data-photo-help','');help.textContent='Not sure of the model? Choose/type “Other / not sure” and send a clear photo of the front or model/serial label in the file step.';old.parentElement.appendChild(help);}}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-onboarding-form"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-s4ow-form]').forEach(function(form){
    var model=form.querySelector('[data-s4ow-model]');
    var project=form.querySelector('[data-s4ow-project]');
    var families=form.querySelectorAll('[data-family]');
    var replacement=form.querySelector('[data-replacement]');
    function familyFor(value){value=(value||'').toUpperCase();if(/^ER-9(15|20|25|40|45)E/.test(value)) return 'er900';if(value.indexOf('NR-')===0) return 'nr500';if(value.indexOf('SPS-3')===0) return 'sps300';if(value.indexOf('SPS-5')===0) return 'sps500';if(value.indexOf('ER-52')===0 || value.indexOf('ER-26')===0) return 'legacy';return '';}
    function isReplacement(){var v=(project&&project.value||'').toLowerCase();return v.indexOf('replace')>-1 || v.indexOf('transfer')>-1 || v.indexOf('add another')>-1;}
    function updateFlow(){
      var active=familyFor(model&&model.value);families.forEach(function(section){section.hidden=section.getAttribute('data-family')!==active;});
      var rep=isReplacement();if(replacement) replacement.hidden=!rep;
      var offset=rep?1:0;
      form.querySelectorAll('[data-core-step]').forEach(function(el){el.textContent=2+offset;});
      form.querySelectorAll('[data-family-step]').forEach(function(el){el.textContent=3+offset;});
      form.querySelectorAll('[data-equipment-step]').forEach(function(el){el.textContent=4+offset;});
      form.querySelectorAll('[data-files-step]').forEach(function(el){el.textContent=5+offset;});
      form.querySelectorAll('[data-timing-step]').forEach(function(el){el.textContent=6+offset;});
    }
    if(model) model.addEventListener('change',updateFlow);if(project) project.addEventListener('change',updateFlow);updateFlow();
    form.addEventListener('submit',function(event){
      event.preventDefault();var email=form.querySelector('[name="purchaser_email"]');var error=form.parentElement.querySelector('[data-s4ow-error]');if(!model||!model.value||!email||!email.value.trim()){if(error) error.hidden=false;if(email&&!email.value.trim()) email.focus();else if(model) model.focus();return;}if(error) error.hidden=true;
      var fd=new FormData(form);var val=function(name){return(fd.get(name)||'').toString().trim();};var all=function(name){return fd.getAll(name).filter(Boolean).join(', ');};
      var fields=[['Business',val('business_name')],['Contact',val('contact_name')],['Email',val('purchaser_email')],['Phone',val('phone')],['Order',val('order_number')],['Model',val('register_model')],['Serial',val('serial_number')],['Quantity',val('register_quantity')],['Project type',val('project_type')],['Old/current model',val('old_model')],['Replacement source material',all('replacement_source')],['Keep same',val('replacement_same')],['Changes from old register',val('replacement_changes')],['Old register operational',val('old_operational')],['Preserve old data',val('preserve_old_data')],['Business type',val('business_type')],['PLU/item count',val('plu_count')],['Departments/groups',val('departments')],['PLU/item notes',val('item_notes')],['Tax setup',val('tax_setup')],['Receipt messages',val('receipt_text')],['Clerks/employees',val('clerk_names')],['Tender/payment keys',val('tender_keys')],['Discounts/special keys',val('special_keys')],['ER900 keyboard',val('er900_keyboard')],['ER900 scanner',val('er900_scanner')],['ER900 keyboard map',val('er900_keyboard_map')],['ER900 PLU options',val('er900_plu_options')],['ER900 devices',val('er900_devices')],['NR keyboard',val('nr_keyboard')],['NR price levels',val('nr_price_levels')],['NR PLU options',val('nr_plu_options')],['NR keyboard/NLU map',val('nr_keyboard_map')],['NR employee security',val('nr_employee_security')],['NR options',all('nr_option')],['SPS300 keyboard',val('sps300_keyboard')],['SPS300 kitchen print',val('sps300_kp')],['SPS300 keyboard map',val('sps300_keyboard_map')],['SPS300 PLU options',val('sps300_plu_options')],['SPS300 messages/clerks',val('sps300_messages_clerks')],['SPS500 PLU status',val('sps500_status')],['SPS500 groups',val('sps500_groups')],['SPS500 levels/modifiers',val('sps500_levels')],['SPS500 kitchen routing',val('sps500_kitchen')],['SPS500 employee authority',val('sps500_employee')],['Legacy items/status',val('legacy_items')],['Legacy clerks/keys',val('legacy_clerks_keys')],['Legacy copy notes',val('legacy_copy')],['Equipment needs',all('setup_need')],['Peripherals',val('peripherals')],['Payment approach',val('payment_approach')],['Payment notes',val('payment_notes')],['Files available',all('upload_type')],['Go-live',val('go_live')],['Urgency',val('urgency')],['Project notes',val('project_notes')]];
      var lines=['SAM4S PROGRAMMING INTAKE',''];fields.forEach(function(row){if(row[1]) lines.push(row[0]+': '+row[1]);});var params=new URLSearchParams();params.set('sam4sdirect_lead_type','Programming');params.set('current_pos_system_or_cash_register',val('register_model'));params.set('message',lines.join('\n'));if(val('payment_approach')==='Would like a merchant-processing review'||val('payment_approach')==='Need integrated or semi-integrated payment options') params.set('sam4sdirect_merchant_processing_interest','Credit Card Processing');var uploadUrl=(form.dataset.uploadUrl||'').trim();if(uploadUrl){try{var destination=new URL(uploadUrl,window.location.origin);params.forEach(function(value,key){destination.searchParams.set(key,value);});window.location.href=destination.toString();return;}catch(e){}}window.location.href='/pages/contact?'+params.toString();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-onboarding-prefill"] && !Shopify.designMode) return;
  try {
    
(function(){
  var params=new URLSearchParams(window.location.search);
  var form=document.querySelector('[data-s4ow-form]');
  if(!form) return;

  var lifecycle=window.SAM4S_MODEL_LIFECYCLE||{current:[],legacy:[],aliases:{}};
  var currentModels=lifecycle.current.map(function(x){return x.model;});
  var legacyModels=lifecycle.legacy.map(function(x){return x.model;});
  var model=form.querySelector('[name="register_model"]');
  var project=form.querySelector('[name="project_type"]');
  var oldModel=form.querySelector('[name="old_model"]');
  var pendingValue='Replacement model not selected yet';

  function normalizeModel(value){
    value=(value||'').trim();
    return lifecycle.aliases[value]||value;
  }
  function currentModelMatch(value){
    var target=normalizeModel(value).toUpperCase();
    var found='';
    for(var i=0;i<currentModels.length;i++){
      var current=currentModels[i];
      if(current.toUpperCase()===target) return current;
      if(target.indexOf(current.toUpperCase())!==-1){
        if(found) return '';
        found=current;
      }
    }
    return found;
  }
  function replacementMode(){
    var v=(project&&project.value||'').toLowerCase();
    return v.indexOf('replace')>-1 || v.indexOf('transfer')>-1 || v.indexOf('add another')>-1;
  }

  if(model){
    Array.prototype.forEach.call(model.options,function(option){
      if(lifecycle.aliases[option.value] && option.value!=='ER-925'){
        option.value=lifecycle.aliases[option.value];
        option.textContent=lifecycle.aliases[option.value];
      }
    });
    if(!Array.prototype.some.call(model.options,function(option){return option.value===pendingValue;})){
      var pending=document.createElement('option');
      pending.value=pendingValue;
      pending.textContent='Replacement model not selected yet — help me choose';
      model.appendChild(pending);
    }
  }

  if(oldModel){
    var listId='sam4s-legacy-models-'+Math.random().toString(36).slice(2,8);
    var datalist=document.createElement('datalist');
    datalist.id=listId;
    currentModels.concat(legacyModels).concat(['ER-5200 / ER-5240 Series','SPS-300 Series','ER-260EJ / ER-265EJ','ER-900 / ER-900E Series','Other / not sure']).forEach(function(name){
      var option=document.createElement('option');option.value=name;datalist.appendChild(option);
    });
    oldModel.setAttribute('list',listId);
    oldModel.setAttribute('placeholder','Start typing the old/current SAM4S model');
    oldModel.parentNode.appendChild(datalist);
  }

  function supportMode(){
    var v=(project&&project.value||'').toLowerCase();
    return v.indexOf('programming changes')>-1 || v.indexOf('remote programming')>-1 || v.indexOf('support')>-1;
  }

  function gateModels(){
    if(!model) return;
    var allowLegacy=supportMode();
    var allowPending=replacementMode();
    Array.prototype.forEach.call(model.options,function(option,index){
      if(index===0) return;
      var value=option.value;
      if(value===pendingValue){option.hidden=!allowPending;option.disabled=!allowPending;return;}
      var isCurrent=currentModels.indexOf(value)>-1;
      var isLegacy=legacyModels.indexOf(value)>-1 || /ER-52|NR-500|SPS-500/.test(value) || value==='ER-925';
      if(value==='Other / not listed'){option.hidden=false;option.disabled=false;return;}
      if(isCurrent){option.hidden=false;option.disabled=false;return;}
      if(isLegacy){option.hidden=!allowLegacy;option.disabled=!allowLegacy;}
    });
    if(model.selectedOptions.length && model.selectedOptions[0].disabled){model.value='';model.dispatchEvent(new Event('change',{bubbles:true}));}
    var label=model.closest('label');
    if(label){
      var note=label.querySelector('[data-model-note]');
      if(!note){note=document.createElement('small');note.setAttribute('data-model-note','');note.style.fontWeight='500';note.style.color='#536b7e';note.style.lineHeight='1.45';label.appendChild(note);}
      if(allowPending){
        note.textContent='Replacement path: choose the proposed current model if you know it. If not, select “Replacement model not selected yet” and we will verify the right current model from your old register and requirements.';
      }else{
        note.textContent=allowLegacy?'Support/programming mode: current and legacy SAM4S families are available.':'New setup: choose the current SAM4S model being programmed.';
      }
    }
  }

  function reconcile(existing,incoming){
    if(!incoming) return {write:false,conflict:false};
    if(existing===incoming) return {write:false,conflict:false};
    return {write:true,conflict:!!existing};
  }

  var draftConflict=false;
  var urlApplied={};
  var aliases=[['model','register_model'],['serial','serial_number'],['qty','register_quantity'],['quantity','register_quantity'],['order','order_number'],['order_number','order_number'],['old','old_model'],['old_model','old_model'],['email','purchaser_email'],['phone','phone'],['business','business_name'],['contact','contact_name'],['project_type','project_type']];
  aliases.forEach(function(pair){
    var value=params.get(pair[0]);if(!value) return;
    if(pair[1]==='register_model') value=normalizeModel(value);
    var field=form.querySelector('[name="'+pair[1]+'"]');if(!field) return;
    var decision=reconcile(field.value,value);
    if(!decision.write) return;
    if(decision.conflict) draftConflict=true;
    urlApplied[pair[1]]=true;
    field.value=value;field.dispatchEvent(new Event('change',{bubbles:true}));
  });

  var replacementParam=currentModelMatch(params.get('replacement_model'));
  if(model && replacementParam){
    var replacementDecision=reconcile(model.value,replacementParam);
    if(replacementDecision.write){
      if(replacementDecision.conflict && !urlApplied['register_model']) draftConflict=true;
      model.value=replacementParam;
      model.dispatchEvent(new Event('change',{bubbles:true}));
    }
  }
  if(project) project.addEventListener('change',function(){
    gateModels();
    if(replacementMode() && model && !model.value && oldModel && oldModel.value.trim()){
      model.value=pendingValue;
      model.dispatchEvent(new Event('change',{bubbles:true}));
    }
  });

  gateModels();
  if(replacementMode() && model && !model.value && oldModel && oldModel.value.trim()){
    model.value=pendingValue;
    model.dispatchEvent(new Event('change',{bubbles:true}));
  }

  if(params.get('old_model') || params.get('replacement_model')){
    var head=(form.closest('.s4ow__wrap')||document).querySelector('.s4ow__head');
    if(head && !head.querySelector('[data-replacement-prefill-note]')){
      var note=document.createElement('div');
      note.setAttribute('data-replacement-prefill-note','');
      note.style.marginTop='16px';note.style.padding='13px 15px';note.style.border='1px solid #c9ddea';note.style.borderRadius='10px';note.style.background='#eef6fb';note.style.color='#334e68';note.style.lineHeight='1.5';
      note.innerHTML='<strong>Replacement details carried forward.</strong> Your old register'+(oldModel&&oldModel.value?' ('+oldModel.value+')':'')+' has been added to this worksheet.'+(replacementParam?' The proposed current replacement ('+replacementParam+') is also preselected for verification.':' We have not assumed a new model; choose “Replacement model not selected yet” if you want us to verify the best current replacement.');
      head.appendChild(note);
    }
  }

  if(draftConflict){
    var conflictHead=(form.closest('.s4ow__wrap')||document).querySelector('.s4ow__head');
    if(conflictHead && !conflictHead.querySelector('[data-draft-conflict-note]')){
      var conflictNote=document.createElement('div');
      conflictNote.setAttribute('data-draft-conflict-note','');
      conflictNote.style.marginTop='12px';conflictNote.style.padding='11px 14px';conflictNote.style.border='1px solid #e4d5ab';conflictNote.style.borderRadius='10px';conflictNote.style.background='#fff8e9';conflictNote.style.color='#625a48';conflictNote.style.lineHeight='1.5';
      conflictNote.textContent='Your saved draft was preserved. Model details were updated from the link you just followed.';
      conflictHead.appendChild(conflictNote);
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-processing-intake"] && !Shopify.designMode) return;
  try {
    
(function(){
  var form=document.querySelector('[data-s4pi-form]');if(!form)return;
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var fd=new FormData(form);function v(n){return(fd.get(n)||'').toString().trim();}function all(n){return fd.getAll(n).filter(Boolean).join(', ');}
    var rows=[['Business type',v('business_type')],['Locations',v('locations')],['Registers / lanes',v('lanes')],['Current register / POS',v('current_system')],['Current processor',v('current_processor')],['Current terminal',v('current_terminal')],['Approx. monthly card volume',v('volume')],['Average ticket',v('ticket')],['Programs / features to review',all('review')],['Payment workflow',v('workflow')],['Payment equipment ownership',v('equipment_status')],['Switching assistance to review',all('assistance')],['Contract / equipment / compatibility concerns',v('concerns')],['Goal',v('goal')]];
    var lines=['MERCHANT PROCESSING DISCOVERY',''];rows.forEach(function(r){if(r[1])lines.push(r[0]+': '+r[1]);});
    var q=new URLSearchParams();q.set('sam4sdirect_lead_type','Merchant Processing Interest');q.set('sam4sdirect_merchant_processing_interest','Credit Card Processing');if(v('current_system'))q.set('current_pos_system_or_cash_register',v('current_system'));q.set('message',lines.join('\n'));
    var inboundSource = new URLSearchParams(window.location.search).get('source_page') || '';
    var sourceShape = /^sam4sdirect:[a-z0-9][a-z0-9._-]{0,99}$/;
    var fallbackSource = 'sam4sdirect:' + window.location.pathname.replace(/\/$/, '').split('/').pop();
    if (sourceShape.test(inboundSource)) q.set('source_page', inboundSource);
    else if (sourceShape.test(fallbackSource)) q.set('source_page', fallbackSource);
    window.location.href='/pages/contact?'+q.toString()+'#sam4s-contact-form';
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-programming-manual-enhancements"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){
    var form=document.querySelector('[data-s4ow-form]');
    if(!form) return;
    var model=form.querySelector('[name="register_model"]');
    var project=form.querySelector('[name="project_type"]');
    if(!model) return;

    var equipment=form.querySelector('[data-equipment-step]');
    var equipmentSection=equipment&&equipment.closest('.s4ow__section');
    var section=document.createElement('div');
    section.className='s4ow__section s4me';
    section.setAttribute('data-s4me-section','');
    section.hidden=true;
    if(equipmentSection) equipmentSection.parentNode.insertBefore(section,equipmentSection); else form.appendChild(section);

    function esc(s){return String(s||'').replace(/[&<>\"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
    function isReplacement(){var v=(project&&project.value||'').toLowerCase();return /replace|transfer|add another/.test(v);}
    function heading(title,copy){return '<div class="s4ow__section-head"><span>+</span><div><h3>'+esc(title)+'</h3><p>'+esc(copy)+'</p></div></div>';}
    function field(label,name,placeholder){return '<label class="s4ow__wide">'+esc(label)+'<textarea rows="3" name="'+name+'" placeholder="'+esc(placeholder||'')+'"></textarea></label>';}
    function select(label,name,options){return '<label>'+esc(label)+'<select name="'+name+'"><option value="">Select one</option>'+options.map(function(x){return '<option>'+esc(x)+'</option>';}).join('')+'</select></label>';}
    function checks(legend,name,items){return '<fieldset class="s4ow__checks s4ow__wide"><legend>'+esc(legend)+'</legend>'+items.map(function(x){return '<label><input type="checkbox" name="'+name+'" value="'+esc(x)+'"> '+esc(x)+'</label>';}).join('')+'</fieldset>';}

    function render(){
      var value=(model.value||'').toUpperCase();
      var html='';
      var legacy=form.querySelector('[data-family="legacy"]');
      if(legacy && /^ER-26(0EJ|5EJ)/.test(value)) legacy.hidden=true;

      if(/^ER-9(15|20|25|40|45)E/.test(value)){
        var kb=[];
        if(value==='ER-915E') kb=['Default 7 double-wide NLU/PLU keys','Expanded 14 single NLU/PLU keys','Not sure / have us confirm'];
        else if(value==='ER-925E'||value==='ER-945E') kb=['Default 21 double-wide PLU keys','Expanded 63 PLU keys','Not sure / have us confirm'];
        else kb=['Use standard flat-key layout','Custom key layout / upload marked layout','Not sure / have us confirm'];
        var printers=(value==='ER-915E'||value==='ER-940E'||value==='ER-945E')?'Two printer stations (receipt + journal configuration)':'Single printer station';
        html=heading(value+' programming details','Manual-derived questions for this exact ER-900E model.')+
          '<div class="s4me__fact"><strong>Expected hardware:</strong> '+printers+'. We will verify this against the ordered SKU before programming.</div><div class="s4ow__fields">'+
          select('Keyboard configuration','manual_er900_keyboard_config',kb)+
          select('Confirm printer use','manual_er900_printer_use',['Receipt printing','Journal printing','Receipt + journal / electronic journal as supported','Not sure'])+
          select('Integrated EMV payment planned?','manual_er900_integrated_pay',['No','Yes','Maybe / need recommendation'])+
          select('SD card available for integrated payment/program utilities?','manual_er900_sd',['Yes','No','Not sure'])+
          field('Exact keyboard changes / expanded keys','manual_er900_key_changes','Tell us which PLUs or functions must be placed on the keyboard, or upload a marked layout.')+
          field('Payment device / processor details','manual_er900_payment_device','If integrated payment is planned, list terminal/device and processor information you know.')+
          '</div>';
      } else if(/^NR-51/.test(value) || value.indexOf('NR-500E')===0){
        html=heading(value+' programming & restore details','The NR family can preserve or selectively restore many program areas, so replacement jobs need a few compatibility checks.')+
          '<div class="s4ow__fields">'+
          (isReplacement()?select('Old-register program source','manual_nr_backup_source',['SD program backup','USB program backup','eSpresso PC Utility backup','Printed program scan only','No backup available','Not sure']):'')+
          (isReplacement()?select('Old-register firmware version known?','manual_nr_old_fw_known',['Yes - enter below','No','Register is unavailable']):'')+
          (isReplacement()?field('Old and new firmware versions, if known','manual_nr_firmware','A restore is safest when source/destination firmware compatibility is confirmed.'):'')+
          (isReplacement()?select('Memory allocation/program allocation available?','manual_nr_memory_alloc',['Yes - included in scan/backup','Yes - I can provide it','No','Not sure']):'')+
          (isReplacement()?checks('Program areas you want preserved/restored','manual_nr_restore_area',['PLUs/items','Groups','Taxes','System/print options','Function keys','Clerks/employees','Descriptions/messages/logos','Stock','Macros','Mix & Match','NLU assignments','Ports/peripherals','Keyboard layout']):'')+
          select('Integrated EMV payment planned?','manual_nr_integrated_pay',['No','Yes','Maybe / need recommendation'])+
          select('Active internet/network available at the register?','manual_nr_internet',['Yes - wired Ethernet','Yes - network/router available; connection method needs verification','No','Not sure'])+
          select('SD card available/installed for payment or program backup?','manual_nr_sd',['Yes','No','Not sure'])+
          field('Payment terminal / Datacap / processor details','manual_nr_payment_device','List the PIN pad/terminal, Datacap setup, processor, network details or anything already installed.')+
          '</div>';
      } else if(/^ER-26(0EJ|5EJ)/.test(value)){
        var is265=value==='ER-265EJ';
        html=heading(value+' current-model programming details','This is a current model. These questions replace the generic legacy block for ER-260EJ/265EJ.')+
          '<div class="s4me__fact"><strong>Keyboard:</strong> '+(is265?'Flat spill-resistant keyboard with programmable key locations; suited to food-service counters.':'Raised keyboard with 15 keyboard PLU keys; well suited to retail/scanning workflows.')+'</div><div class="s4ow__fields">'+
          select('How will items normally be entered?','manual_er26_item_entry',['Keyboard PLU/department keys','Barcode scanner','Combination of keys and scanner','Not sure'])+
          select('Printer mode','manual_er26_printer_mode',['Receipt','Journal','Receipt with electronic journal','Not sure'])+
          select('Barcode scanner planned?','manual_er26_scanner',['No','Yes','Maybe / need recommendation'])+
          select('Program Save/Load source available for a transfer?','manual_er26_backup',['SD card','USB/eSpresso or other existing backup','Printed program information only','No backup','Not applicable'])+
          select('Semi-integrated payment planned?','manual_er26_payment',['No','Yes','Maybe / need recommendation'])+
          checks('Connected options to configure','manual_er26_device',['Kitchen printer','Slip printer','Scale','Scanner','Pole/customer display','Kitchen video','Video surveillance','Semi-integrated payment'])+
          field('Receipt preamble/postamble and logo notes','manual_er26_receipt','Up to six preamble and six postamble lines are supported; tell us what should print and whether you have a logo file.')+
          (is265?field('Flat-key/menu layout','manual_er26_layout','Describe the key locations you need, or upload a marked key sheet.'):'')+
          '</div>';
      } else if(/^SPS-3(20|40|45)/.test(value) || value==='SPS-300 SERIES'){
        var raised=value==='SPS-345';
        html=heading(value+' programming details','SPS-300 programming varies by keyboard, PLU layout, clerk method and restaurant/retail workflow.')+
          '<div class="s4me__fact"><strong>Default keyboard:</strong> '+(raised?'SPS-345 raised keyboard has 21 PLU keys and can be expanded to 63.':'SPS-320/SPS-340 flat keyboard provides 100 PLUs on the default layout.')+'</div><div class="s4ow__fields">'+
          (raised?select('SPS-345 keyboard size','manual_sps300_keyboard_size',['Standard 21 PLU keys','Expanded 63 PLU keys','Not sure']):select('Flat-key layout','manual_sps300_flat_layout',['Use standard/default layout','Custom PLU/function layout','Not sure']))+
          select('Clerk sign-on method','manual_sps300_clerk_mode',['Simple push-button clerk','Code-entry clerks','Employee card / MSR','Not sure'])+
          select('Clerk behavior','manual_sps300_clerk_behavior',['Stay-down','Pop-up after each transaction','Not sure'])+
          select('Menu/price levels needed?','manual_sps300_levels',['One/basic level','Multiple menu/price levels','Not sure'])+
          select('Age verification needed?','manual_sps300_age',['No','Yes - alcohol','Yes - tobacco','Yes - multiple age categories','Not sure'])+
          select('Barcode scanning planned?','manual_sps300_scan',['No','Yes','Maybe'])+
          checks('Advanced programming used','manual_sps300_advanced',['Guest checks/accounts','PLU modifiers/sizes','Mix & Match discounts','Food stamp/EBT item handling','Employee timekeeping','Macros','Electronic journal','Kitchen/remote printing'])+
          field('Keyboard/menu layout details','manual_sps300_layout','List important PLU/function key locations, menu levels or upload a marked keyboard layout.')+
          '</div>';
      }

      if(html){section.innerHTML=html;section.hidden=false;}else{section.innerHTML='';section.hidden=true;}
    }

    function summarize(){
      var values=[];
      section.querySelectorAll('input,select,textarea').forEach(function(el){
        if(!el.name) return;
        if((el.type==='checkbox'||el.type==='radio')&&!el.checked) return;
        var v=(el.value||'').trim();if(!v) return;
        var label=el.closest('label');var text=label?label.textContent.trim().replace(/\s+/g,' '):el.name;
        if(el.type==='checkbox'||el.type==='radio') text=el.name;
        values.push(text+': '+v);
      });
      return values;
    }

    if(model) model.addEventListener('change',render);
    if(project) project.addEventListener('change',render);
    render();

    form.addEventListener('submit',function(){
      var notes=form.querySelector('[name="project_notes"]');
      if(!notes) return;
      var marker='\n\n--- MODEL-SPECIFIC MANUAL DETAILS ---\n';
      var base=notes.value.split(marker)[0];
      var detail=summarize();
      notes.value=base+(detail.length?marker+detail.join('\n'):'');
    },true);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-purchase-options"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Carry the chosen method into the existing contact request. No pricing is
     read or written here: selecting a method must never change a product price
     or a cart, only what the specialist is told. */
  var root = document.currentScript && document.currentScript.closest('.s4popt');
  document.querySelectorAll('.s4popt').forEach(function (node) {
    var cta = node.querySelector('[data-s4popt-cta]');
    if (!cta) return;
    var base = cta.getAttribute('href');
    node.addEventListener('change', function (e) {
      if (!e.target || e.target.name !== 'purchaseMethod') return;
      var sep = base.indexOf('?') === -1 ? '?' : '&';
      var hash = base.indexOf('#') === -1 ? '' : base.slice(base.indexOf('#'));
      var stem = hash ? base.slice(0, base.indexOf('#')) : base;
      cta.setAttribute(
        'href',
        stem + sep + 'purchase_method_interest=' + encodeURIComponent(e.target.value) + hash
      );
    });
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-reorder-center"] && !Shopify.designMode) return;
  try {
    
(function(){document.querySelectorAll('[data-s4re-form]').forEach(function(form){form.addEventListener('submit',function(e){e.preventDefault();var model=(form.querySelector('[name="model"]').value||'').trim();var need=form.querySelector('[name="need"]').value||'';if(!model){form.querySelector('[name="model"]').focus();return;}var p=new URLSearchParams();p.set('sam4sdirect_lead_type','Parts / Accessories');p.set('current_pos_system_or_cash_register',model);p.set('message','SAM4S ACCESSORY COMPATIBILITY REQUEST\nModel: '+model+'\nNeed: '+need);window.location.href='/pages/contact?'+p.toString();});});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-service-intake"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ssi-form]').forEach(function(form){
    form.addEventListener('submit',function(event){
      event.preventDefault();
      var fd=new FormData(form);
      function val(name){return(fd.get(name)||'').toString().trim();}
      function all(name){return fd.getAll(name).filter(Boolean).join(', ');}
      var required=['email','register_model','request_type','urgency','symptom'];
      var missing=required.some(function(name){return !val(name);});
      var error=form.querySelector('[data-ssi-error]');
      if(missing){
        if(error)error.hidden=false;
        var firstName=required.find(function(n){return !val(n);});
        var first=form.querySelector('[name="'+firstName+'"]');
        if(first)first.focus();
        return;
      }
      if(error)error.hidden=true;
      var rows=[
        ['Business',val('business_name')],['Contact',val('contact_name')],['Email',val('email')],['Phone',val('phone')],
        ['SAM4S model',val('register_model')],['Serial number',val('serial_number')],['Order number',val('order_number')],['Purchase source',val('purchase_source')],
        ['Support coverage',val('support_coverage')],['Request type',val('request_type')],['Urgency',val('urgency')],['Started',val('started_when')],
        ['Powers on',val('powers_on')],['Can ring sale',val('can_ring_sale')],['Error/message',val('error_message')],['Symptom',val('symptom')],
        ['Recent change',val('recent_change')],['Connected equipment',all('equipment')],['Peripheral models',val('peripheral_models')],['Already tried',val('tried')],['Files available',val('files_available')]
      ];
      var lines=['SAM4S SUPPORT / SERVICE INTAKE',''];
      rows.forEach(function(row){if(row[1])lines.push(row[0]+': '+row[1]);});
      var params=new URLSearchParams();
      var lead=val('request_type')==='Programming'?'Programming':'Technical Support';
      params.set('sam4sdirect_lead_type',lead);
      params.set('current_pos_system_or_cash_register',val('register_model'));
      params.set('message',lines.join('\n'));
      window.location.href='/pages/contact?'+params.toString();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-submit-normalizer"] && !Shopify.designMode) return;
  try {
    
(function(){
function boot(){
 var form=document.querySelector('[data-s4ow-form]');if(!form)return;
 var model=form.querySelector('[name="register_model"]'),old=form.querySelector('[name="old_model"]'),notes=form.querySelector('[name="project_notes"]');
 var pending='Replacement model not selected yet';
 form.addEventListener('submit',function(){
  if(!model||model.value!==pending)return;
  var oldValue=old?(old.value||'').trim():'';if(!oldValue)return;
  if(notes){var marker='\n\n--- REPLACEMENT TARGET STATUS ---\n';var base=notes.value.split(marker)[0];notes.value=base+marker+'New/replacement model: Not selected yet — verify the appropriate current SAM4S replacement before quoting or programming.\nOld/current register model: '+oldValue;}
 },true);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-technician-programming-spec"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){
    var form=document.querySelector('[data-s4ow-form]');
    if(!form||form.querySelector('[name="technician_programming_spec"]')) return;
    var hidden=document.createElement('textarea');
    hidden.name='technician_programming_spec';
    hidden.hidden=true;
    hidden.setAttribute('aria-hidden','true');
    form.appendChild(hidden);

    function one(name){
      var el=form.querySelector('[name="'+name+'"]');
      return el?(el.value||'').toString().trim():'';
    }
    function all(name){
      var values=[];
      Array.prototype.forEach.call(form.querySelectorAll('[name="'+name+'"]'),function(el){
        if((el.type==='checkbox'||el.type==='radio')&&!el.checked) return;
        var value=(el.value||'').toString().trim();
        if(value) values.push(value);
      });
      return values;
    }
    function line(lines,label,value){
      if(value) lines.push(label+': '+value);
    }
    function build(){
      var lines=[];
      lines.push('SAM4SDIRECT TECHNICIAN PROGRAMMING SPEC');
      lines.push('========================================');
      line(lines,'Business',one('business_name'));
      line(lines,'Contact',one('contact_name'));
      line(lines,'Email',one('purchaser_email'));
      line(lines,'Phone',one('phone'));
      line(lines,'Order',one('order_number'));
      line(lines,'Target model',one('register_model'));
      line(lines,'Serial',one('serial_number'));
      line(lines,'Quantity',one('register_quantity'));
      line(lines,'Project type',one('project_type'));
      line(lines,'Old/current model',one('old_model'));
      line(lines,'Business type',one('business_type'));
      line(lines,'Store address',one('business_address'));
      line(lines,'City',one('business_city'));
      line(lines,'State',one('business_state'));
      line(lines,'ZIP',one('business_postal_code'));
      line(lines,'Store phone for receipt',one('receipt_phone'));
      line(lines,'Receipt contact text',one('receipt_contact'));

      lines.push('');
      lines.push('CORE PROGRAMMING');
      lines.push('----------------');
      line(lines,'Departments / reporting groups',one('departments'));
      line(lines,'Approximate PLU/item count',one('plu_count'));
      line(lines,'PLU/item notes',one('item_notes'));
      line(lines,'Tax setup',one('tax_setup'));
      line(lines,'Receipt text',one('receipt_text'));
      line(lines,'Clerks / employees',one('clerk_names'));
      line(lines,'Tender / payment keys',one('tender_keys'));
      line(lines,'Discounts / special keys',one('special_keys'));
      line(lines,'Connected equipment',all('setup_need').join(', '));
      line(lines,'Peripheral details',one('peripherals'));
      line(lines,'Payment approach',one('payment_approach'));
      line(lines,'Payment notes',one('payment_notes'));

      lines.push('');
      lines.push('MODEL-SPECIFIC PROGRAMMING');
      lines.push('--------------------------');
      var modelSpecific=[];
      var seenModel={};
      Array.prototype.forEach.call(form.elements,function(el){
        if(!el.name||el.disabled||seenModel[el.name]) return;
        if(!/^(er900_|nr_|sps300_|sps500_|legacy_|manual_)/.test(el.name)) return;
        if((el.type==='checkbox'||el.type==='radio')){
          var vals=all(el.name);
          if(vals.length) modelSpecific.push(el.name+': '+vals.join(', '));
        }else{
          var value=(el.value||'').toString().trim();
          if(value) modelSpecific.push(el.name+': '+value);
        }
        seenModel[el.name]=true;
      });
      if(modelSpecific.length){
        modelSpecific.forEach(function(value){lines.push(value);});
      }else{
        lines.push('[No additional model-specific values entered]');
      }

      if((one('register_model')||'').toUpperCase()==='ER-945E'){
        lines.push('');
        lines.push('ER-945E DETAILED PROGRAM');
        lines.push('------------------------');
        line(lines,'Receipt printing',one('er945_receipt_mode'));
        line(lines,'Clerk sign-on required',one('er945_clerk_signon'));
        line(lines,'Tax jurisdiction / source',one('er945_tax_jurisdiction'));
        line(lines,'Tender names',one('er945_tenders'));
        line(lines,'Operating restrictions',one('er945_operating_rules'));

        lines.push('');
        lines.push('PLU KEYS');
        for(var i=1;i<=21;i++){
          var name=one('er945_plu_'+i+'_name');
          var type=one('er945_plu_'+i+'_type');
          var price=one('er945_plu_'+i+'_price');
          var tax=one('er945_plu_'+i+'_tax');
          if(name||type||price||tax){
            lines.push('PLU '+i+' | Name: '+(name||'[blank]')+' | '+(type||'[type not set]')+' | Price: '+(price||'[open/blank]')+' | Tax: '+(tax||'[not set]'));
          }
        }

        lines.push('');
        lines.push('TAX TABLES');
        for(var t=1;t<=4;t++){
          var rate=one('er945_tax_'+t+'_rate');
          var mode=one('er945_tax_'+t+'_mode');
          var applies=one('er945_tax_'+t+'_applies');
          if(rate||mode||applies) lines.push('Tax '+t+' | Rate: '+(rate||'[blank]')+' | '+(mode||'[mode not set]')+' | Applies to: '+(applies||'[not specified]'));
        }

        lines.push('');
        lines.push('RECEIPT HEADER');
        for(var h=1;h<=6;h++) line(lines,'Line '+h,one('er945_header_'+h));
        lines.push('');
        lines.push('RECEIPT FOOTER');
        for(var f=1;f<=6;f++) line(lines,'Line '+f,one('er945_footer_'+f));

        lines.push('');
        lines.push('CLERKS');
        for(var c=1;c<=8;c++){
          var id=one('er945_clerk_'+c+'_id');
          var cname=one('er945_clerk_'+c+'_name');
          var notes=one('er945_clerk_'+c+'_notes');
          if(id||cname||notes) lines.push('Clerk '+c+' | ID: '+(id||'[blank]')+' | Name: '+(cname||'[blank]')+' | Permissions: '+(notes||'[not specified]'));
        }

        lines.push('');
        line(lines,'Peripherals',one('er945_peripherals'));
        line(lines,'Additional programming',one('er945_additional'));
        line(lines,'Existing program source',one('er945_existing_program'));
        line(lines,'Preferred transfer method',one('er945_transfer_preference'));

        lines.push('');
        lines.push('TECHNICIAN QA CHECKLIST');
        lines.push('[ ] Confirm exact model is ER-945E');
        lines.push('[ ] Record / verify serial number');
        lines.push('[ ] Confirm keyboard layout before programming');
        lines.push('[ ] Verify each programmed PLU descriptor, price and tax assignment');
        lines.push('[ ] Verify tax rates and add-on/included behavior');
        lines.push('[ ] Verify receipt header/footer');
        lines.push('[ ] Verify clerk sign-on and permissions');
        lines.push('[ ] Verify tender keys / payment workflow');
        lines.push('[ ] Verify scanner, scale, terminal and other peripherals');
        lines.push('[ ] Run test sale');
        lines.push('[ ] Print and review receipt');
        lines.push('[ ] Run test refund / void only if authorized');
        lines.push('[ ] Print applicable program/report verification');
        lines.push('[ ] Save backup / configuration when supported');
        lines.push('[ ] Mark programming complete before shipment');
      }

      lines.push('');
      lines.push('SOURCE / FILES');
      lines.push('--------------');
      line(lines,'Replacement material',all('replacement_source').join(', '));
      line(lines,'Files/photos available',all('upload_type').join(', '));
      line(lines,'What stays the same',one('replacement_same'));
      line(lines,'Requested changes',one('replacement_changes'));

      lines.push('');
      lines.push('TIMING / NOTES');
      lines.push('--------------');
      line(lines,'Go-live date',one('go_live'));
      line(lines,'Urgency',one('urgency'));
      line(lines,'Project notes',one('project_notes'));

      hidden.value=lines.join('\n');
    }

    form.addEventListener('input',build);
    form.addEventListener('change',build);
    form.addEventListener('submit',build,true);
    build();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-video-invite"] && !Shopify.designMode) return;
  try {
    
/*
 * Swap the facade for a real player on click. One delegated listener for the
 * whole document, guarded so two placements on one page do not bind twice.
 *
 * Nothing here runs before a click, and nothing third-party is fetched before
 * a click. That is the entire performance argument for the facade.
 */
(function () {
  if (window.__s4vVideoBound) return;
  window.__s4vVideoBound = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var button = target.closest('[data-s4v-play]');
    if (!button) return;

    var embed = button.getAttribute('data-s4v-embed');
    var frame = button.parentNode;
    if (!embed || !frame) return;

    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', embed);
    iframe.setAttribute('title', button.getAttribute('aria-label') || 'Video');
    iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.className = 's4v__player';

    frame.replaceChild(iframe, button);

    // Move focus into the player so a keyboard user lands on the controls.
    if (typeof iframe.focus === 'function') iframe.focus();
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam4s-warranty-eligibility"] && !Shopify.designMode) return;
  try {
    
(function(){document.querySelectorAll('[data-s4war-form]').forEach(function(form){form.addEventListener('submit',function(e){e.preventDefault();var v=function(n){return(form.querySelector('[name="'+n+'"]').value||'').trim();};var email=v('email'),model=v('model'),err=form.querySelector('[data-s4war-error]');if(!email||!model){if(err)err.hidden=false;(!email?form.querySelector('[name="email"]'):form.querySelector('[name="model"]')).focus();return;}if(err)err.hidden=true;var lines=['SAM4S WARRANTY / PROTECTION CHECK','Email: '+email,'Order: '+(v('order_number')||'Not provided'),'Model: '+model,'Serial: '+(v('serial')||'Not provided'),'Purchase date: '+(v('purchase_date')||'Not provided'),'Request: '+v('request')];if(v('notes'))lines.push('Notes: '+v('notes'));var p=new URLSearchParams();p.set('sam4sdirect_lead_type','Existing Customer');p.set('current_pos_system_or_cash_register',model);p.set('message',lines.join('\n'));window.location.href='/pages/contact?'+p.toString();});});})();

  } catch(e) { console.error(e); }
})();
})();
